var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowOutwardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98595 8.38913C9.0034 8.19114 9.09871 8.00818 9.25097 7.88042C9.40322 7.75267 9.59995 7.69057 9.79796 7.70777L15.7855 8.23161C15.9835 8.24906 16.1664 8.34438 16.2942 8.49663C16.422 8.64888 16.484 8.84562 16.4668 9.04362L15.943 15.0312C15.9191 15.224 15.8214 15.4001 15.6704 15.5225C15.5194 15.6448 15.3268 15.7038 15.1332 15.6872C14.9396 15.67 14.7603 15.5784 14.6328 15.4317C14.5053 15.285 14.4397 15.0946 14.4496 14.9005L14.8157 10.7163L9.11635 15.4986C8.96397 15.6265 8.76705 15.6886 8.56889 15.6712C8.37074 15.6539 8.18758 15.5585 8.05972 15.4062C7.93187 15.2538 7.86978 15.0569 7.88711 14.8587C7.90445 14.6606 7.99979 14.4774 8.15217 14.3495L13.8515 9.56721L9.66731 9.20113C9.46932 9.18369 9.28636 9.08837 9.1586 8.93612C9.03085 8.78387 8.96875 8.58713 8.98595 8.38913Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOutwardIcon);
export default __webpack_public_path__ + "static/media/ArrowOutwardIcon.e083344eda75b12b5061f36dbf93664f.svg";
export { ForwardRef as ReactComponent };